import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import { ROUTES,SITE } from '@/constants'
import MetaInfo from '@common/MetaInfo'
import TransformBanner from '@sections/TransformBanner'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.AI_INTEGRATION_APPLICATION_DEVELOPMENT)
const EXTEND_TRADITIONAL_FUNCTIONALITY = [
  {title: 'AI-Powered Search & Information Discovery',desc: 'Help users find relevant information without relying entirely on exact keywords or complex navigation. AI-assisted search can interpret natural-language questions, identify relevant content and present more useful results.',example:'An enterprise portal could allow employees to search policies, project records and internal documentation using everyday language.' },
  {title: 'Intelligent Document Processing',desc: 'Extract, classify, summarize and validate information from documents that would otherwise require considerable manual effort. Depending on the document and use case, AI can help process forms, invoices, reports, applications and supporting records.',example:'A clinic automation software could extract information from submitted reports and summarise to the doctors for further review.' },
  {title: 'AI-Enabled Application Assistants',desc: 'Add conversational capabilities to existing applications so users can ask questions, retrieve information or receive guided assistance without leaving their usual working environment.',example:'A customer service portal could help users understand service options, locate relevant documentation and navigate common support processes.' },
  {title: 'AI-Ready Application Architecture',desc: 'Prepare applications to support AI-powered features through suitable APIs, data integration, access controls, logging and modular architecture. This can make it easier to introduce additional capabilities as business needs evolve.',example:'' },
]

const AI_CREATE_VALUES = [
  { title: 'Government & Public Services',desc: 'Help users navigate information, process submissions and find relevant programme details.' },
  { title: 'Healthcare',desc: 'Assist with administrative document processing, appointment enquiries and information retrieval, subject to appropriate privacy and clinical safeguards.' },
  { title: 'Retail & E-commerce',desc: 'Improve product discovery, recommendations, customer enquiries and catalog management.' },
  { title: 'Manufacturing',desc: 'Help teams retrieve maintenance information, summarize equipment reports and access technical documentation.' },
  { title: 'Banking & Financial Services',desc: 'Support document classification, customer service and information extraction, with suitable controls for sensitive decisions.' },
  { title: 'Enterprise & SaaS Platforms',desc: 'Introduce intelligent search, contextual assistance, content processing and data-driven features within existing products.' }, 
]



const INTEGRATING_AI = [
  { title: `Use-Case Assessment`, desc: 'Identify the application feature or workflow where AI could provide measurable value.', },
  { title: 'Technology Selection', desc: 'Evaluate suitable AI models, APIs, frameworks and deployment approaches.', },
  { title: 'Data & Integration Planning', desc: 'Determine how the feature will access relevant information and connect with existing systems.', },
  { title: 'Development & Validation', desc: 'Build the feature and test its accuracy, performance, usability and behaviour in relevant scenarios.', },
  { title: 'Deployment & Improvement', desc: 'Integrate it into the application, monitor its performance and refine it as usage and requirements evolve.', },
 
]
export default function AiIntegrationApplicationDevelopment() {
  

  return (
    <> <MetaInfo
      title={`${label} ${SITE.metaTagPostText}`} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- AI/ML Solutions -</div> */}
              <Breadcrumb />
              <h1 data-aos="fade-up" data-aos-delay={100}>
                {/* Data & ML Engineering */}
                {label}
                </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Build scalable data platforms that power AI-driven business decisions. */}
             {pageDesc}
             </p>
            
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={200}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
         {/* section 1 */}
        <section className="bg-linear-gradient-light section-py " >
      <div className="container">
           

        {/* Row 2 — */}
         <p className='text-center' data-aos="fade-down">
             Artificial Intelligence / Super Intelligence can do much more than just powering your standalone tools. When integrated thoughtfully into business applications, it can make everyday software more capable, responsive and useful.
         </p>
      
        {/* <div className="py-4 text-center" data-aos="fade-right">
          <div className='text-highlight-light'>
           Make Your Applications More Intelligent with AI
          </div>
        </div>   */}
            <p className='text-center' data-aos="fade-down">
             At CruxBytes, we can integrate AI capabilities into new and existing web applications, mobile apps, enterprise platforms and SaaS products. Whether you want to introduce an intelligent search feature, automate document interpretation or deliver more personalized user experiences, we help turn practical AI opportunities into working software features.
         </p>
         <p className='text-center' data-aos="fade-down">
             Our approach combines established software engineering practices with appropriate AI technologies, so new capabilities fit into your application architecture, workflows and business objectives.
         </p>
         <h6 className='pt-4 text-center'>Extend Your Software Beyond Traditional Functionality</h6>
        <div className="wcs-grid wcs-grid--3 pt-4">
          {EXTEND_TRADITIONAL_FUNCTIONALITY.map((card, i) => (
            <div
              key={card.title}
              className="wcs-card-offer"
              data-aos="fade-left"
              data-aos-delay={(i % 3) * 80}
            >
              {/* <i className={`${card.icon} wcs-icon`} aria-hidden="true" /> */}
              <h3 className="wcs-offer-title">{card.title}</h3>
              <p className="wcs-offer-desc">{card.desc}</p>
             
             {card.example !== "" && <><h6 className='pt-4'>Example: </h6> 
             <p className="wcs-offer-desc">{card.example}</p></>}
            </div>
          ))}
        </div>
      </div>
    </section>
    {/* section 2 */}
    <section className="section-py " aria-labelledby="pux-outcomes-heading">
  <div className="container">
    <div className="sc-ai-row sc-tm-row--sticky-heading">
      <div className="sc-tm-content" data-aos="fade-left">        
     <h2 id="impact-heading" >
            <span className="impact-heading-dark">Where AI Integration</span>
            <span className="impact-heading-light">Can Create Value</span>
          </h2>
          
      </div>
      <div  data-aos="fade-right">
        <div className="wcs-grid wcs-grid--3">
          {AI_CREATE_VALUES.map((card, i) => (
            <div
              key={card.title}
              className="wcs-card wcs-card--static wcs-card--start  bg-peach"
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 80}
            >             
              <h3 className="wcs-title"  >{card.title}</h3>
              <p className="wcs-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
   
  <div className="comparison-intro mb-0" data-aos="fade-left">
  <div className='pt-4 d-flex align-items-center'>
    <h5>Make Your Applications More Intelligent with AI</h5>
</div>

  <div className="wcs-actions comparison-intro-cta"  data-aos="fade-right">
    <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right">
                  Get Started
      </Button>
  </div>
</div>
  </div>
</section>

  {/* ── Section 3 */}
        <section className="section-py  bgs-section--tint" aria-labelledby="egovernance-partner-heading" style={{ borderRadius:"0" }}>
          

          <div className="container">
           <div className="" data-aos="fade-up">
              <div className="section-card__content ">
                <h2 className='text-center' id="egovernance-partner-heading">
                  Our AI Strategy Consulting Services
                </h2>
               
              </div>
          <p data-aos="fade-up" className='section-px2'>AI adoption does not always require a new platform. In many cases, the more practical option is to enhance an application that already serves a business purpose. Our development process can include:</p>
            <div className="wcs-grid">
              {INTEGRATING_AI.map((item, i) => (
                <div
                  key={item.title}
                  className="wcs-card wcs-card-5  bg-white"
                  data-aos="fade-up"
                  data-aos-delay={i * 80}
                >
                  <h3 className="text-secondary wcs-title" >0{i+1}</h3>
                  {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}
                  {/* <i className={`fa-solid ${item.icon} wcs-icon`} aria-hidden="true" /> */}
                  <h3 className="text-secondary wcs-title">{item.title}</h3>
                  <p className="text-secondary wcs-desc">{item.desc}</p>
                </div>
              ))}
            </div>
            <p data-aos="fade-up" className='section-px2 pt-4'>The exact approach depends on the application's architecture, data sensitivity, expected usage and reliability requirements.</p>
            
            </div>
          </div>
        </section>
         {/* Section4 */}
      <section className="section-py ">
                <div className="container ">
        <div className="on-demand-split">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
        
          <div className="cp-timeline-header">
            <h2 >Built Around Your Existing Technology</h2>
            <p >
            Your application may start with a focused requirement and eventually become a critical business platform. We therefore design applications with future expansion in mind.
            </p>
            <p>Whether you are developing a new digital product or improving a mature business application, CruxBytes can help you identify where AI fits and engineer it into the software experience.</p>
          </div>     
        </div>
                          {/* ── RIGHT:  ── */}
          <div   data-aos="fade-left">  
            <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>
              <h6>Give Your Existing Software New Capabilities</h6>
              <p style={{ paddingBottom: '1.2rem' }}>
                Explore how AI can extend your web applications, mobile apps, enterprise systems or SaaS products with features designed around real business needs.
              </p>
              
            </div>
          </div>

                  </div>
         
                </div>
         </section>
         <TransformBanner />
         </main></>
  )
}